import React from 'react' 
import mofa from '../../assets/mofa.png'
import mojha from '../../assets/mojha.png' 
import {AiOutlineClose} from 'react-icons/ai'
import { useAppContext } from '../../context/Context'

function Popup() {
  const {popup, setPopup}= useAppContext()
  return (
            <div className={`popup ${popup? "active": ""}`} onClick={()=>setPopup(false)}>
              <div onClick={()=>setPopup(false)} className="popup-button">
              <AiOutlineClose/>
              </div>
              <div className="popup-content">
                <a href="https://mofa.opengov.mn/login"><div className="popup-mofa"><img alt="mofa" src={mofa}/></div></a>
                <a href="https://mojha.opengov.mn/login"><div className="popup-mojha"><img alt="mojha" src={mojha}/></div></a>
              </div>
            </div>
  )
}

export default Popup